import { Card, CardContent, CardActions, Typography, Button, Chip } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

interface Props {
  title: string;
  description: string;
  badge?: string;
  route: string;
}

export default function ToolCard({ title, description, badge, route }: Props) {
  const navigate = useNavigate();
  return (
    <Card
      variant="outlined"
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        transition: 'box-shadow 0.2s',
        '&:hover': { boxShadow: 3 },
      }}
    >
      <CardContent sx={{ flex: 1 }}>
        <Typography variant="subtitle1" fontWeight={600} gutterBottom>
          {title}
        </Typography>
        {badge && (
          <Chip label={badge} size="small" color="secondary" sx={{ mb: 1, fontSize: '0.7rem' }} />
        )}
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </CardContent>
      <CardActions sx={{ px: 2, pb: 2 }}>
        <Button
          size="small"
          variant="contained"
          endIcon={<ArrowForward />}
          onClick={() => navigate(route)}
        >
          Try Now
        </Button>
      </CardActions>
    </Card>
  );
}
